import type {PublicMethodUtils, PS} from '@wix/document-services-types'
import type {OptimusMigrationPublicAPI} from '@wix/document-services-public-types'
import {variants as variantsImpl} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'
import type {AppsInstallStateExtensionAPI} from '@wix/document-manager-extensions'
import _ from 'lodash'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<OptimusMigrationPublicAPI> {
    const {defineGetter, defineDataManipulationAction} = publicMethodUtils

    const setAppInstalledFromExt = (ps: PS, appDefId: string): void => {
        const {appsInstallState} = ps.extensionAPI as AppsInstallStateExtensionAPI
        appsInstallState.setAppInstalled(appDefId)
    }
    const setAppUninstalledFromExt = (ps: PS, appDefId: string): void => {
        const {appsInstallState} = ps.extensionAPI as AppsInstallStateExtensionAPI
        appsInstallState.setAppUninstalled(appDefId)
    }

    const fixNestedPresets = (ps: PS) => {
        const allPresets = ps.extensionAPI.data.query('presets')
        let count = 0
        const allRefArrPresets = _.filter(allPresets, {type: 'RefArray'})
        _.forEach(allRefArrPresets, preset => {
            const presetId = preset.values[0].replace('#', '')
            const presetVal = ps.dal.get({id: presetId, type: 'presets'})
            if (presetVal.type === 'RefArray') {
                const presetValToSave = presetVal.values
                ps.dal.remove({id: presetId, type: 'presets'})
                const currToFix = _.cloneDeep(preset)
                currToFix.values = presetValToSave
                ps.dal.set({id: preset.id, type: 'presets'}, currToFix)
                ps.dal.commitTransaction()
                count++
            }
        })
        return count
    }

    return {
        methods: {
            optimusMigration: {
                presets: {
                    fixNestedPresets: defineDataManipulationAction(fixNestedPresets)
                },
                document: {
                    validate: publicMethodUtils.extensionPublicAPI.immediate('validation.validate')
                },
                components: {
                    innerElements: {
                        variants: {
                            getAllAffectingVariantsGroupedByVariantType: defineGetter(
                                variantsImpl.getAllAffectingVariantsGroupedByVariantTypeForInnerElement
                            )
                        }
                    }
                },
                appsState: {
                    setAppUninstalled: defineDataManipulationAction(setAppUninstalledFromExt),
                    setAppInstalled: defineDataManipulationAction(setAppInstalledFromExt)
                }
            }
        }
    }
}
